<template>
  <div>
    <page-header title="Перевозка прицепа" />
    <div class="public-container public-container-mobile shipping-types">
      <div id="about" class="shipping-types-banner-wrapper mb-60">
        <div class="shipping-types-banner mb-30">
          <public-card-info img-url="/images/pages/shipping-type/trailer.png">
            <div class="shipping-types-card-text">
              {{ content.blocks.about.cardText }}
            </div>
          </public-card-info>
        </div>

        <div>
          <h2 class="vz-text-align-left">
            {{ content.blocks.about.pageTitle }}
          </h2>
          <p>Заказать перевозку можно в несколько кликов удобным способом:</p>
          <help-services param />
        </div>

        <div class="shipping-types-block trailer-services">
          <h2 class="vz-text-align-left">
            {{ content.blocks.about.title }}
          </h2>
          <div class="shipping-types-info-item">
            <vz-icon
              url="/svg/icon/vz-home.svg"
              variant="primary"
              no-masked-icon
            />
            <div>
              <div class="shipping-types-info-item-title">Адресная доставка</div>
              <p v-html="content.blocks.about.addressText" />
            </div>
          </div>
          <div class="shipping-types-info-item">
            <vz-icon
              url="/svg/box-transportation.svg"
              variant="primary"
              no-masked-icon
            />
            <div>
              <div class="shipping-types-info-item-title">Погрузо-разгрузочные работы</div>
              <p v-html="content.blocks.about.pprText" />
            </div>
          </div>
          <div class="shipping-types-info-item">
            <vz-icon
              url="/svg/package.svg"
              variant="primary"
              no-masked-icon
            />
            <div>
              <div class="shipping-types-info-item-title">Упаковка</div>
              <p v-html="content.blocks.about.wrappingText" />
            </div>
          </div>
        </div>
      </div>

      <shipping-types-buttons />

      <div id="transport" class="shipping-types-banner-wrapper mb-60 shipping-types-block">
        <div class="shipping-types-banner mb-30">
          <public-card-attention :text="content.blocks?.transport.attention" />
        </div>
        <div>
          <h2 class="vz-text-align-left">
            {{ content.blocks?.transport.title }}
          </h2>
          <ul class="public-list public-list-square">
            <li v-for="item of content.blocks?.transport.list.split(';')">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>

      <public-info-grid class="shipping-types-block mb-90" :items="items" rounded-style />

      <shipping-types-chain current="trailer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import HelpServices from '~/components/public/help/help-services.vue';
import PublicCardAttention from '~/components/public/public-card-attention.vue';
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import PublicInfoGrid from '~/components/public/public-info-grid.vue';
import {PublicInfoGridItem} from '~/types/public';
import {getPageContent} from '~/api/content';

const content = await getPageContent('/shippingtypes/trailer')

const items = computed((): PublicInfoGridItem[] => [
  {
    title: content.blocks.transport.insuranceTitle,
    text: content.blocks.transport.insuranceText,
    icon: {
      name: 'shield'
    },
  },
  {
    title: content.blocks.transport.storageTitle,
    text: content.blocks.transport.storageText,
    icon: {
      url: '/svg/vz-safe.svg'
    }
  },
])
</script>

<style lang="scss" scoped>
.trailer-services {
  @media screen and (max-width: $pub-xs) {
    order: 3;
  }
}
</style>
